import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import ILocalState from './stateInterface';

const initState: ILocalState = {
    myProjectsList: null,
    activeProject: null,
    allProjectItems: null,
    activeSingleReport: null,
    projectOverview: null,
};

export default {
    namespaced: true,
    state: initState,
    getters,
    actions,
    mutations,
};
